import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-ink-200 bg-ink-50 mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-gold-light to-gold-500 flex items-center justify-center">
              <GraduationCap className="w-5 h-5 text-white" strokeWidth={2.4} />
            </div>
            <div className="font-display text-lg font-bold text-ink-900">E.C.S</div>
          </div>
          <p className="text-sm text-ink-600 leading-relaxed">
            Education, Certification, School.<br />
            Apprenez sérieusement, sans vous prendre la tête.
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-ink-900 mb-3 text-sm">Plateforme</h4>
          <ul className="space-y-2 text-sm text-ink-600">
            <li><Link to="/categories" className="hover:text-gold-600">Catégories</Link></li>
            <li><Link to="/recrutement" className="hover:text-gold-600">Recrutement</Link></li>
            <li><Link to="/faq" className="hover:text-gold-600">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-gold-600">Nous contacter</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-ink-900 mb-3 text-sm">Juridique</h4>
          <ul className="space-y-2 text-sm text-ink-600">
            <li><Link to="/terms" className="hover:text-gold-600">Conditions générales</Link></li>
            <li><Link to="/privacy" className="hover:text-gold-600">Politique de confidentialité</Link></li>
            <li className="text-xs text-ink-500">RGPD — données hébergées en UE</li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-ink-900 mb-3 text-sm">Important</h4>
          <p className="text-xs text-ink-600 leading-relaxed">
            Les certificats E.C.S sont des <strong className="text-ink-900">certifications privées de connaissances</strong>.
            Ils ne constituent pas des diplômes d'État ni des qualifications médicales officielles.
          </p>
        </div>
      </div>

      <div className="border-t border-ink-200">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-ink-500">
          <span>© {new Date().getFullYear()} E.C.S — Tous droits réservés.</span>
          <span className="font-mono">v1.1</span>
        </div>
      </div>
    </footer>
  );
}
